import moment from 'moment';
import { find, filter, some } from 'lodash';

import './dashboard.style.sass';
import template from './dashboard.tpl.pug';

class DashboardController {
    /* @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        let time = this.time
            ? moment(this.time)
            : moment();

        this.cashFlow = {
            start: moment(time).startOf('month').valueOf(),
            end: moment(time).endOf('month').valueOf()
        };

        this.incomeExpense = {
            year: moment(time).year()
        };

        this.category = {
            start: moment(time).startOf('month').valueOf(),
            end: moment(time).endOf('month').valueOf(),
            confirmed: 'true'
        };

        this.categoryConfirmedFilterOptions = [
            { id: 'true', value: 'Confirmed' },
            { id: 'false', value: 'Unconfirmed' },
            { id: 'any', value: 'All' }
        ];
    }

    updateCashFlowPeriod(start, end) {
        this.cashFlow.start = start;
        this.cashFlow.end = end;
    }

    updateIncomeExpenseYear(year) {
        this.incomeExpense.year = year;
    }

    updateCategoryPeriod(start, end) {
        this.category.start = start;
        this.category.end = end;
    }

    updateCategoryConfirmed(confirmed) {
        this.category.confirmed = confirmed;
    }

    isTeamActive(team) {
        return this.selectedTeam === team;
    }

    isCalendarActive(calendar) {
        return this.getCalendarIndex(calendar) >= 0;
    }

    selectTeam(team) {
        this.selectedTeam = team;
        this.calendarIds = [this.selectedTeam.calendars[0].id];
    }

    getCalendarIndex(calendar) {
        return this.calendarIds.indexOf(calendar.id);
    }

    getCalendarIdsOfCalendar(calendar) {
        let team = findTeamCalendarBelongsTo(this.teams, calendar);

        let index = this.getCalendarIndex(calendar);
        let calendarIds = filter(this.calendarIds, (id) => teamHasCalendarId(team, id));

        if (index < 0) {
            calendarIds.push(calendar.id);
        } else if (calendarIds.length > 1) {
            calendarIds.splice(index, 1);
        }

        return calendarIds;
    }

    selectCalendar(calendar) {
        this.calendarIds = this.getCalendarIdsOfCalendar(calendar);
    }

    getTeamName(team) {
        return team ? team.name : null;
    }

    getCalendarName(calendar) {
        return calendar ? calendar.name : null;
    }

    getCalendarId(calendar) {
        return calendar.id;
    }

    getCalendarPlaceholder() {
        return this.calendars && this.calendars.length > 1
            ? `${this.calendars[0].name} and ${this.calendars.length - 1} more`
            : null;
    }
}

function teamHasCalendar(team, calendar) {
    return some(team.calendars, (item) => compareCalendar(calendar, item));
}

function teamHasCalendarId(team, calendarId) {
    return some(team.calendars, (calendar) => calendar.id === calendarId);
}

function findTeamCalendarBelongsTo(teams, calendar) {
    return find(teams, (team) => teamHasCalendar(team, calendar));
}

function compareCalendar(calendar, anotherCalendar) {
    return calendar.id === anotherCalendar.id;
}

export default {
    selector: 'dbADashboard',
    template: template(),
    controller: DashboardController,
    bindings: {
        teams: '<',
        selectedTeam: '<',
        calendarIds: '<',
        startOfWeek: '<',
        time: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/dashboard.cmpt.js